export const messages = {
  en: {
    applyGoldWithdrawal: {
      title: 'Gold Withdrawal Application',
      communityName: 'Community Name',
      communityNamePlaceholder: 'Please select community',
      choose: 'Choose',
      goldName: 'Account Name',
      goldNamePlaceholder: 'Required, please enter account name',
      amount: 'Gold Amount',
      amountPlaceholder: 'Required, please enter gold amount',
      applyAmount: 'Withdrawal Amount',
      applyAmountPlaceholder: 'Required, please enter withdrawal amount',
      applyUserName: 'Applicant',
      applyUserNamePlaceholder: 'Required, please enter applicant name',
      applyUserTel: 'Applicant Phone',
      applyUserTelPlaceholder: 'Required, please enter applicant phone',
      bankNum: 'Bank Account',
      bankNumPlaceholder: 'Required, please enter bank account',
      bankNumName: 'Account Name',
      bankNumNamePlaceholder: 'Required, please enter account name',
      bankName: 'Bank Name',
      bankNamePlaceholder: 'Required, please enter bank name',
      remark: 'Application Note',
      remarkPlaceholder: 'Required, please enter application note',
      cancel: 'Cancel',
      save: 'Save'
    }
  },
  zh: {
    applyGoldWithdrawal: {
      title: '金币提现',
      communityName: '小区名称',
      communityNamePlaceholder: '请选择小区',
      choose: '选择',
      goldName: '账户名称',
      goldNamePlaceholder: '必填，请填写账户名称',
      amount: '金币金额',
      amountPlaceholder: '必填，请填写金币金额',
      applyAmount: '提现金额',
      applyAmountPlaceholder: '必填，请填写提现金额',
      applyUserName: '申请人',
      applyUserNamePlaceholder: '必填，请填写申请人',
      applyUserTel: '申请人电话',
      applyUserTelPlaceholder: '必填，请填写申请人电话',
      bankNum: '银行账户',
      bankNumPlaceholder: '必填，请填写银行账户',
      bankNumName: '账号名称',
      bankNumNamePlaceholder: '必填，请填写账号名称',
      bankName: '开户行',
      bankNamePlaceholder: '必填，请填写开户行',
      remark: '申请说明',
      remarkPlaceholder: '必填，请填写申请说明',
      cancel: '取消',
      save: '保存'
    }
  }
}